module.exports = __webpack_public_path__ + "static/media/header.46bf7da7.png";